import { useQuery } from 'data-fetching-client';
import { GET_SEAT_REQUESTS_ADMIN } from 'pricing-pages-api/request-seat/queries';
import { useAppSelector } from '../reducers';
import { isUngatedForFTSStagedUsersSelector } from '../selectors/GatingSelectors';
/**
 * Hook to fetch seat requests for a portal
 */
export const useSeatRequestsAdmin = ({
  skip = false
}) => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_SEAT_REQUESTS_ADMIN, {
    skip
  });
  return {
    requestedSeatsForAdmin: (data === null || data === void 0 ? void 0 : data.requestedSeatsForAdmin) || [],
    error,
    loading
  };
};

/**
 * Filter seat requests to only include staged users
 */
export const useStagedUsersFromSeatRequests = () => {
  const isUngatedForStagedUsers = useAppSelector(isUngatedForFTSStagedUsersSelector);
  const {
    requestedSeatsForAdmin,
    error,
    loading
  } = useSeatRequestsAdmin({
    skip: !isUngatedForStagedUsers
  });
  return {
    stagedUsersList: requestedSeatsForAdmin.filter(seatRequest => seatRequest.status === 'STAGED'),
    error,
    loading
  };
};